import axios from 'axios';

import { env } from '@/shared/config/env';

import { toApiError } from './api-error';
import { tokenManager } from './token-manager';

// Authenticated storefront client. The backend uses long-lived Sanctum Bearer
// tokens with NO refresh flow, so a 401 is terminal: clear the token and notify
// the auth layer to drop the session (which redirects to login).
export const httpClient = axios.create({
  baseURL: env.apiUrl,
  timeout: 15_000,
  headers: { Accept: 'application/json' },
});

let onUnauthorized;

export function setUnauthorizedHandler(handler) {
  onUnauthorized = handler;
}

httpClient.interceptors.request.use((config) => {
  const token = tokenManager.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      tokenManager.clear();
      onUnauthorized?.();
    }
    throw toApiError(error);
  },
);
